// ===== Sticky header shadow =====
(function(){
  var h=document.querySelector('.site-header'); if(!h) return;
  window.addEventListener('scroll',function(){
    h.classList.toggle('is-scrolled', window.scrollY>20);
  });
})();

// ===== Announcement rotator =====
(function(){
  var el=document.querySelector('[data-announcement]'); if(!el) return;
  var msgs=JSON.parse(el.getAttribute('data-messages')||'[]'); if(!msgs.length) return;
  var i=0;
  setInterval(function(){ i=(i+1)%msgs.length; el.textContent=msgs[i]; },4500);
})();

// ===== Mobile menu =====
(function(){
  var t=document.querySelector('[data-menu-toggle]');
  var m=document.querySelector('[data-mobile-menu]');
  if(!t||!m) return;
  t.addEventListener('click',function(){ m.classList.toggle('is-open'); });
  m.addEventListener('click',function(e){ if(e.target.tagName==='A'||e.target.hasAttribute('data-menu-close')) m.classList.remove('is-open'); });
})();

// ===== Accordion =====
document.addEventListener('click',function(e){
  var b=e.target.closest('.accordion__btn'); if(!b) return;
  b.parentElement.classList.toggle('is-open');
});

// ===== Cart drawer =====
(function(){
  var d=document.getElementById('cart-drawer'); if(!d) return;
  document.querySelectorAll('[data-cart-open]').forEach(function(b){
    b.addEventListener('click',function(e){e.preventDefault();d.classList.add('is-open');});
  });
  d.querySelectorAll('[data-cart-close]').forEach(function(b){
    b.addEventListener('click',function(){d.classList.remove('is-open');});
  });
})();

// ===== Count-up stats =====
(function(){
  var els=document.querySelectorAll('[data-countup]'); if(!els.length) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting) return;
      var el=en.target, target=parseInt(el.getAttribute('data-countup'),10), suffix=el.getAttribute('data-suffix')||'';
      var start=0, dur=1500, t0=performance.now();
      function tick(t){
        var p=Math.min(1,(t-t0)/dur);
        el.textContent=Math.floor(start+(target-start)*p).toLocaleString()+suffix;
        if(p<1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  },{threshold:.4});
  els.forEach(function(e){io.observe(e);});
})();

// ===== Viewer count =====
(function(){
  var el=document.querySelector('[data-viewer-count]'); if(!el) return;
  el.textContent=Math.floor(Math.random()*15)+8;
})();

// ===== Sticky ATC =====
(function(){
  var s=document.querySelector('.sticky-atc'); var trigger=document.querySelector('[data-atc-trigger]');
  if(!s||!trigger) return;
  window.addEventListener('scroll',function(){
    var r=trigger.getBoundingClientRect();
    s.classList.toggle('is-visible', r.bottom<0);
  });
})();

// ===== Gallery thumbs =====
(function(){
  var main=document.querySelector('[data-gallery-main]'); if(!main) return;
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
    t.addEventListener('click',function(){ main.src=t.dataset.src; });
  });
})();

// ===== Recent purchase toast =====
(function(){
  var root=document.getElementById('toast-root'); if(!root) return;
  var pool=[
    {who:'James from Detroit',what:'requested a quote for 2× Extra Vision 48" Showcases'},
    {who:'Maria from Chicago',what:'requested a quote for Silver Extra Vision Showcase'},
    {who:'Devon from Cleveland',what:'requested a quote for Black Gondola Starter Run'},
    {who:'Priya from Toledo',what:'requested a quote for Lighted Tower Display Case'},
    {who:'Carlos from Grand Rapids',what:'requested a quote for Female Mannequin Set (3)'},
    {who:'Anna from Indianapolis',what:'requested a quote for Slatwall Merchandiser'},
    {who:'Marcus from Columbus',what:'requested a quote for Platinum Gondola End Caps'}
  ];
  function show(){
    var p=pool[Math.floor(Math.random()*pool.length)];
    var t=document.createElement('div');
    t.className='toast';
    t.innerHTML='<div><div class="who">Just Quoted</div><div class="what"><strong>'+p.who+'</strong> '+p.what+'</div></div>';
    root.appendChild(t);
    setTimeout(function(){t.remove();},5500);
  }
  setTimeout(function(){ show(); setInterval(show, 75000); }, 8000);
})();
